import React, { useState, useEffect, useContext } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import AgentRegisteredDrivers from "../Drivers/AgentRegisteredDrivers";
import { Button } from "react-bootstrap";
import TableSmall from "../Theme/TableSmall";
import { Card, CardContent, Grid } from "@mui/material";
import { Link, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Badge from "@mui/material/Badge";
import { UserContext } from "../UserContext";
import Edit from "../Drivers/Edit";
import SubAgent from "../VehicleType/SubAgent/SubAgentForAgetDashboard";
import { Tabs, Tab, Box, Typography, Paper } from "@mui/material";
import { BusinessCenter } from "@mui/icons-material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarViewDayIcon from "@mui/icons-material/CalendarViewDay";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AgentTransactions from "../Accounting/AgentTransactions";
const DashboardAgent = ({ role }) => {
  const edit = "agentDetails";
  const detail = "driver-by-sub-agent";
  const [agents, setAgents] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const [drivers, setDrivers] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [earnings, setEarnings] = useState([]);
  const location = useLocation();

  let [driversLoading, setDriversLoading] = useState(false);
  let [loading, setLoading] = useState(false);
  let [transactionsLoading, setTransactionsLoading] = useState(false);
  let [earningsLoading, setEarningsLoading] = useState(false);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const iconSize = 50;

  const getDrivers = async () => {
    try {
      let user = JSON.parse(localStorage.getItem("userData"));
      // setId(userId.id);
      const response = await axios
        .get(
          role === "agent"
            ? "drivers/byAgent/" + user.id
            : "drivers/bySubAgent/" + user.id
        )
        .then((res) => {
          console.log(res);

          setDrivers(res.data);
          setDriversLoading(false);
          // notify()
        });
    } catch (error) {
      notifyError();
    }
  };
  const getEarnings = async () => {
    let user = JSON.parse(localStorage.getItem("userData"));
    const response = await axios
      .get(
        role === "agent"
          ? "agent/earnings/" + user.id
          : "sub-agent/earnings/" + user.id
      )
      .then((res) => {
        console.log(res);

        setEarnings(res.data);
        setEarningsLoading(false);
        // notify()
      })
      .catch((err) => {
        notifyError();
      });
  };
  useEffect(() => {
    getDrivers();
    getEarnings();
  }, [location.key]);

  const user = useContext(UserContext);
  let usr = JSON.parse(localStorage.getItem("userData"));
  let roles = JSON.parse(localStorage.getItem("roleData"));

  const [id, setId] = useState(null);
  const [data, setData] = useState(null);

  const [displayEditModal, setDisplayEditModal] = useState(false);
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const showEditModal = (id) => {
    setId(id);

    axios.get("/driver/" + id, {}).then((res) => {
      setData(res.data.driver);
      console.log("=====clicked========");
      setDisplayEditModal(true);
    });
  };


  const notify = () =>
    toast.success("Drivers list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  useEffect(() => {
    getAgents();
  }, []);

  const getAgents = async () => {
    let user = JSON.parse(localStorage.getItem("userData"));
    const response = await axios.get("sub-agents/" + user.id).then(notify());

    setAgents(response.data);
  };

  const [refetchDriver, setRefetchDriver] = useState(false);

  return (
    <div className="content-wrappers">
      <div className="content-header">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-3">
                <Paper
                  elevation={3}
                  style={{ padding: "20px", marginBottom: "20px" }}
                >
                  <BusinessCenter style={{ color: "#0aa0de", fontSize: 400 }} />
                  {usr && (
                    <div style={{ textAlign: "center" }}>
                      <Typography variant="h5" gutterBottom>
                        Agent Profile
                      </Typography>
                      <Typography variant="h6" gutterBottom>
                        {usr.name}
                      </Typography>

                      <Typography variant="body1" gutterBottom>
                        Phone Number: {usr.phone}
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        Status: {usr.status}
                      </Typography>
                    </div>
                  )}
                </Paper>
              </div>
              <div className="col">
                <Tabs value={currentTab} onChange={handleTabChange}>
                  <Tab label="Drivers" />

                  {roles.filter(function (e) {
                    return e.perm_name === "list_sub_agents";
                  }).length > 0 && <Tab label="Sub Agents" />}
                  <Tab label="Transactions" />
                  <Tab label="Earnings" />
                </Tabs>
                {currentTab === 1 && (
                  <TabPanel value={currentTab} index={1}>
                    {roles.filter(function (e) {
                      return e.perm_name === "list_sub_agents";
                    }).length > 0 && <SubAgent />}
                  </TabPanel>
                )}
                {currentTab === 0 && (
                  <TabPanel value={currentTab} index={0}>
                    <AgentRegisteredDrivers
                      drivers={drivers}
                      setDrivers={setDrivers}
                      getDrivers={getDrivers}
                    />
                  </TabPanel>
                )}

                {currentTab === 2 && (
                  <TabPanel value={currentTab} index={2}>
                    <AgentTransactions />
                  </TabPanel>
                )}

                {currentTab === 3 && (
                  <TabPanel value={currentTab} index={3}>
                    {earningsLoading ? (
                      <Spinner />
                    ) : (
                      <div className="card card-primary card-outline">
                        {earningsLoading && (
                          <div>
                            <Spinner />
                          </div>
                        )}
                        {!earningsLoading && (
                          <Card elevation={3}>
                            <CardContent>
                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={4}>
                                  <div
                                    className="small-box"
                                    style={{
                                      backgroundColor: "#0aa0de",
                                    }}
                                  >
                                    <div className="inner">
                                      <h3 style={{ color: "white" }}>
                                        {earnings.dailyRevenue.toFixed(2)}
                                      </h3>

                                      <p style={{ color: "white" }}>Today</p>
                                    </div>

                                    <div className="icon">
                                      <CalendarTodayIcon
                                        style={{
                                          color: "white",
                                          fontSize: 100,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                  <div
                                    className="small-box"
                                    style={{
                                      backgroundColor: "#0aa0de",
                                    }}
                                  >
                                    <div className="inner">
                                      <h3 style={{ color: "white" }}>
                                        {earnings?.weeklyRevenue?.toFixed(2)}
                                      </h3>

                                      <p style={{ color: "white" }}>
                                        Past 7 Days
                                      </p>
                                    </div>

                                    <div className="icon">
                                      <CalendarViewDayIcon
                                        style={{
                                          color: "white",
                                          fontSize: 100,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Grid>{" "}
                                <br />
                                <Grid item xs={12} sm={6} md={4}>
                                  <div
                                    className="small-box"
                                    style={{
                                      backgroundColor: "#0aa0de",
                                    }}
                                  >
                                    <div className="inner">
                                      <h3 style={{ color: "white" }}>
                                        {earnings.monthlyRevenue.toFixed(2)}
                                      </h3>

                                      <p style={{ color: "white" }}>
                                        Past 30 Days
                                      </p>
                                    </div>

                                    <div className="icon">
                                      <CalendarMonthIcon
                                        style={{
                                          color: "white",
                                          fontSize: 100,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                  <div
                                    className="small-box"
                                    style={{
                                      backgroundColor: "#0aa0de",
                                    }}
                                  >
                                    <div className="inner">
                                      <h3 style={{ color: "white" }}>
                                        {earnings.totalRevenue.toFixed(2)}
                                      </h3>

                                      <p style={{ color: "white" }}>Total</p>
                                    </div>

                                    <div className="icon">
                                      <CalendarMonthIcon
                                        style={{
                                          color: "white",
                                          fontSize: 100,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Grid>
                               
                              </Grid>
                            </CardContent>
                          </Card>
                        )}
                      </div>
                    )}
                  </TabPanel>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardAgent;
const ReportInfo = ({ title, value }) => {
  return (
    <div className="report-info">
      <Typography variant="body1">{title}</Typography>
      <Typography variant="h6" color="primary">
        {value.toFixed(2)}
      </Typography>
    </div>
  );
};
const TabPanel = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};
